module.exports = __webpack_public_path__ + "static/media/pdf-icon.4d4ef161.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/pdf-icon.svg
// module id = 864
// module chunks = 21